import { render, staticRenderFns } from "./admin-vip.vue?vue&type=template&id=500cc1e8&scoped=true"
import script from "./admin-vip.vue?vue&type=script&lang=js"
export * from "./admin-vip.vue?vue&type=script&lang=js"
import style0 from "./admin-vip.vue?vue&type=style&index=0&id=500cc1e8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cc1e8",
  null
  
)

export default component.exports